import api from 'api'
import { WageRate } from './getRule'

type AddRateRequest = {
  ruleId: number
  hourlyRateCents: number
  note?: string | null
  isEnabled: boolean
}

export const addRate = async (request: AddRateRequest): Promise<WageRate> => {
  const response = await api.post<WageRate>(
    `/admin/wage/rules/${request.ruleId}/rates`,
    {
      hourlyRateCents: request.hourlyRateCents,
      note: request.note ?? null,
      isEnabled: request.isEnabled,
    }
  )
  return response.data
}
